"use client";
import React from "react";
import cx from "classnames";
import { LinksBlock } from "./children/LinksBlock";
import { linksBlockDefaultDataOne as linksAboutHaven, linksBlockDefaultDataThree as linksHelpfulLinks, bottomMenuDefaultData as linksPolicies, linksBlockDefaultDataTwo as linksTypeOfHolidays, socialMenuDefaultData as socialMenu, } from "./defaultData";
import styles from "./Footer.module.scss";
const generateAnalytics = (analytics) => (menuListItem) => {
    if (menuListItem.className === "ot-sdk-show-settings") {
        const data = {
            event: "visitor interaction",
            interactionName: "cookie preferences click",
            linkType: "footer",
            linkText: menuListItem.title.toLowerCase(),
            linkUrl: null,
        };
        analytics === null || analytics === void 0 ? void 0 : analytics(data);
    }
};
export const Footer = ({ analytics = () => { }, showNavigation = true, theme, }) => {
    const pushAnalytics = generateAnalytics(analytics);
    return (<footer className={cx(styles.footer, {
            [styles.footerSecondary]: theme === "secondary",
        })}>
      <div className={styles.content}>
        <div className={cx(styles.footerTop, {
            [styles.footerSimple]: !showNavigation,
        })}>
          <small className={styles.copyRightText}>{`© Haven ${new Date().getUTCFullYear()}. All rights reserved`}</small>
          {!showNavigation && (<ul className={styles.bottomMenu}>
              {linksPolicies.links.map((link) => (<li className={styles.bottomMenuItem} key={link.linkUrl}>
                  <a className={`${styles.bottomMenuLink} ${link.className}`} href={link.linkUrl} onClick={() => pushAnalytics(link)}>
                    {link.title}
                  </a>
                </li>))}
            </ul>)}
          <ul className={styles.socialMenu}>
            {socialMenu.links.map((link) => (<li key={link.title}>
                <a className={styles.socialMenuLink} href={link.linkUrl} rel="noopener noreferrer" target="_blank">
                  <img className={styles.socialMenuImage} src={link.icon} alt={link.title} loading="lazy"/>
                </a>
              </li>))}
          </ul>
        </div>
        {showNavigation ? (<nav className={styles.nav}>
            <LinksBlock {...linksTypeOfHolidays}/>
            <LinksBlock {...linksHelpfulLinks}/>
            <LinksBlock {...linksAboutHaven}/>
            <LinksBlock {...linksPolicies} onClick={pushAnalytics}/>
          </nav>) : null}
      </div>
    </footer>);
};
